import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import authService from '@/services/authService'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const token = ref(localStorage.getItem('admin_token') || '')
  const apiKey = ref(localStorage.getItem('admin_api_key') || '')

  const isAuthenticated = computed(() => !!token.value && !!user.value)

  async function login(email, password) {
    const response = await authService.login(email, password)
    if (response.data) {
      const receivedToken = response.data.token || response.data.access_token
      if (!receivedToken) {
        console.error('[Auth] Login response missing token:', response.data)
        throw new Error('No authentication token received from server')
      }
      token.value = receivedToken
      user.value = response.data.user || response.data
      localStorage.setItem('admin_token', token.value)
      console.log('[Auth] Login successful, token stored (length:', token.value.length, ')')
    }
    return response
  }

  function logout() {
    user.value = null
    token.value = ''
    apiKey.value = ''
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_api_key')
  }

  async function fetchProfile() {
    try {
      const response = await authService.getProfile()
      user.value = response.data.user || response.data
    } catch (error) {
      console.error('Failed to fetch profile:', error)
    }
  }

  return {
    user,
    token,
    apiKey,
    isAuthenticated,
    login,
    logout,
    fetchProfile,
  }
})
